module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "tag",
    class: [_vm.typeClass, _vm.sizeClass, _vm.roundedClass],
    style: (_vm.colorStyle)
  }, [_vm._t("default"), _vm._v(" "), (_vm.closable) ? _c('button', {
    staticClass: "delete",
    class: _vm.btnClass,
    on: {
      "click": _vm.handleClose
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d1d96c7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tag/Tag.vue
// module id = 337
// module chunks = 0